export const formatLatLng = (coords: string[] | number[]) => {
  const formatCoord = (coord: string | number) =>
    (typeof coord === "string" ? parseFloat(coord) : coord).toFixed(5);

  return `${formatCoord(coords[1])}°, ${formatCoord(coords[0])}°`;
};
